import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Badge,
  Button,
  Chip,
  IconButton,
  InputBase,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";

import SearchIcon from "@material-ui/icons/Search";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import MicIcon from "@material-ui/icons/Mic";
import SendIcon from "@material-ui/icons/Send";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import EventIcon from "@material-ui/icons/Event";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import AddIcon from "@material-ui/icons/Add";
import PhoneIcon from "@material-ui/icons/Phone";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import api from "../../services/api";

const useStyles = makeStyles(theme => ({
  root: {
    height: "calc(100vh - 72px)",
    background: "#F5F7FB",
    padding: 12,
    boxSizing: "border-box",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
      padding: 0
    }
  },
  shell: {
    height: "100%",
    display: "grid",
    gridTemplateColumns: "360px minmax(0,1fr) 320px",
    gap: 12,
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "340px minmax(0,1fr)"
    },
    [theme.breakpoints.down("sm")]: {
      display: "block"
    }
  },
  panel: {
    background: "#FFFFFF",
    border: "1px solid #E2E8F0",
    borderRadius: 18,
    boxShadow: "0 12px 28px rgba(15,23,42,.06)",
    overflow: "hidden",
    height: "100%"
  },
  listPanel: {
    display: "flex",
    flexDirection: "column"
  },
  listHeader: {
    padding: 16,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  title: {
    fontSize: 22,
    fontWeight: 900,
    color: "#0F172A"
  },
  tabs: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    padding: "0 14px 12px"
  },
  tab: {
    border: "none",
    borderRadius: 12,
    padding: "9px 12px",
    fontWeight: 800,
    fontSize: 12,
    cursor: "pointer",
    background: "#F1F5F9",
    color: "#475569"
  },
  tabActive: {
    background: "rgba(37,99,235,.10)",
    color: "#2563EB",
    boxShadow: "inset 0 0 0 1px rgba(37,99,235,.18)"
  },
  search: {
    margin: "0 14px 12px",
    height: 44,
    borderRadius: 14,
    border: "1px solid #E2E8F0",
    background: "#F8FAFC",
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    gap: 8
  },
  conversations: {
    overflowY: "auto",
    flex: 1,
    padding: "0 8px 12px",
    ...theme.scrollbarStyles
  },
  conversationCard: {
    display: "flex",
    gap: 12,
    padding: 12,
    borderRadius: 16,
    cursor: "pointer",
    border: "1px solid transparent",
    transition: ".18s",
    "&:hover": {
      background: "#F8FAFC",
      borderColor: "#E2E8F0"
    }
  },
  selectedConversation: {
    background: "linear-gradient(90deg, rgba(37,99,235,.10), rgba(255,255,255,1))",
    borderColor: "rgba(37,99,235,.22)"
  },
  convName: {
    fontWeight: 900,
    color: "#0F172A",
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  convMsg: {
    color: "#64748B",
    fontSize: 13,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  convTime: {
    color: "#64748B",
    fontSize: 11,
    fontWeight: 800
  },
  chatPanel: {
    display: "flex",
    flexDirection: "column",
    background: "#F7F3EC"
  },
  chatHeader: {
    minHeight: 78,
    background: "#FFFFFF",
    borderBottom: "1px solid #E2E8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 16px"
  },
  chatUser: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0
  },
  chatBody: {
    flex: 1,
    padding: 20,
    overflowY: "auto",
    background:
      "radial-gradient(circle at 20% 10%, rgba(15,23,42,.025), transparent 20%), #F7F3EC",
    ...theme.scrollbarStyles
  },
  day: {
    margin: "0 auto 18px",
    width: "fit-content",
    background: "#FFFFFF",
    border: "1px solid #E2E8F0",
    color: "#64748B",
    padding: "6px 14px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 800
  },
  bubbleLeft: {
    maxWidth: "68%",
    background: "#FFFFFF",
    color: "#0F172A",
    borderRadius: "16px 16px 16px 4px",
    padding: "10px 12px",
    marginBottom: 10,
    boxShadow: "0 4px 12px rgba(15,23,42,.06)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "86%"
    }
  },
  bubbleRight: {
    maxWidth: "68%",
    marginLeft: "auto",
    background: "#D9FDD3",
    color: "#0F172A",
    borderRadius: "16px 16px 4px 16px",
    padding: "10px 12px",
    marginBottom: 10,
    boxShadow: "0 4px 12px rgba(15,23,42,.06)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "86%"
    }
  },
  bubbleTime: {
    textAlign: "right",
    color: "#64748B",
    fontSize: 11,
    marginTop: 4
  },
  composer: {
    background: "#FFFFFF",
    borderTop: "1px solid #E2E8F0",
    padding: 12
  },
  inputRow: {
    display: "flex",
    gap: 8,
    alignItems: "center"
  },
  inputBox: {
    flex: 1,
    height: 46,
    borderRadius: 999,
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    padding: "0 14px"
  },
  greenButton: {
    background: "#22C55E",
    color: "#FFFFFF",
    "&:hover": { background: "#16A34A" }
  },
  quickActions: {
    display: "flex",
    gap: 8,
    marginTop: 10,
    overflowX: "auto",
    paddingBottom: 2
  },
  quickBtn: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 800,
    color: "#334155",
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    whiteSpace: "nowrap"
  },
  rightPanel: {
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  detailsHeader: {
    padding: 16,
    textAlign: "center",
    borderBottom: "1px solid #E2E8F0"
  },
  detailTabs: {
    display: "flex",
    justifyContent: "center",
    gap: 26,
    borderBottom: "1px solid #E2E8F0",
    paddingTop: 10
  },
  detailTab: {
    paddingBottom: 12,
    color: "#64748B",
    fontWeight: 800,
    fontSize: 13
  },
  detailTabActive: {
    color: "#2563EB",
    borderBottom: "2px solid #2563EB"
  },
  infoCard: {
    margin: 12,
    padding: 14,
    borderRadius: 16,
    border: "1px solid #E2E8F0",
    background: "#FFFFFF"
  },
  infoTitle: {
    color: "#0F172A",
    fontWeight: 900,
    marginBottom: 12
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "#475569",
    fontSize: 13,
    marginBottom: 12
  },
  actionButton: {
    width: "100%",
    justifyContent: "flex-start",
    borderRadius: 12,
    marginBottom: 8,
    textTransform: "none",
    fontWeight: 800,
    border: "1px solid #E2E8F0"
  },
  mobileHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  mobileFull: {
    [theme.breakpoints.down("sm")]: {
      height: "100%",
      borderRadius: 0
    }
  }
}));

const statusMap = {
  all: "Todas",
  open: "Atendendo",
  pending: "Aguardando IA",
  group: "Grupos",
  closed: "Finalizadas"
};

const ConversasV2 = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [status, setStatus] = useState("open");
  const [tickets, setTickets] = useState([]);
  const [counts, setCounts] = useState({});
  const [selected, setSelected] = useState(null);
  const [searchParam, setSearchParam] = useState("");
  const [mobileView, setMobileView] = useState("list");

  const loadTickets = useCallback(async () => {
    try {
      const params = {
        pageNumber: 1,
        showAll: "true",
        searchParam
      };

      if (status !== "all") params.status = status;

      const { data } = await api.get("/tickets", { params });
      setTickets(data.tickets || []);

      if (!selected && data.tickets?.length && !isMobile) {
        setSelected(data.tickets[0]);
      }
    } catch (err) {
      console.error(err);
    }
  }, [status, searchParam, selected, isMobile]);

  const loadCounts = useCallback(async () => {
    try {
      const statuses = ["open", "pending", "group", "closed"];
      const results = await Promise.all(statuses.map(s =>
        api.get("/tickets", { params: { status: s, pageNumber: 1, showAll: "true" } })
      ));

      setCounts({
        open: results[0]?.data?.count || 0,
        pending: results[1]?.data?.count || 0,
        group: results[2]?.data?.count || 0,
        closed: results[3]?.data?.count || 0
      });
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    loadTickets();
  }, [loadTickets]);

  useEffect(() => {
    loadCounts();
  }, [loadCounts]);

  const total = (counts.open || 0) + (counts.pending || 0) + (counts.group || 0) + (counts.closed || 0);

  const formatTime = value => {
    if (!value) return "";
    const d = new Date(value);
    return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  };

  const openConversation = ticket => {
    setSelected(ticket);
    if (isMobile) setMobileView("chat");
  };

  const goRealConversation = () => {
    if (selected?.uuid) history.push(`/tickets/${selected.uuid}`);
  };

  const renderList = () => (
    <div className={`${classes.panel} ${classes.listPanel} ${classes.mobileFull}`}>
      <div className={classes.listHeader}>
        <Typography className={classes.title}>Conversas</Typography>
        <IconButton size="small"><MoreVertIcon /></IconButton>
      </div>

      <div className={classes.tabs}>
        {["all", "open", "pending", "group", "closed"].map(s => (
          <button
            key={s}
            className={`${classes.tab} ${status === s ? classes.tabActive : ""}`}
            onClick={() => {
              setStatus(s);
              setSelected(null);
            }}
          >
            {statusMap[s]} {s === "all" ? total : counts[s] || 0}
          </button>
        ))}
      </div>

      <div className={classes.search}>
        <SearchIcon style={{ color: "#64748B" }} />
        <InputBase
          placeholder="Buscar conversas..."
          value={searchParam}
          onChange={e => {
            setSearchParam(e.target.value);
            setSelected(null);
          }}
          style={{ flex: 1, fontSize: 14 }}
        />
      </div>

      <div className={classes.conversations}>
        {tickets.map(ticket => {
          const name = ticket.contact?.name || "Contato";
          const isSelected = selected?.id === ticket.id;
          const unread = Number(ticket.unreadMessages || 0);

          return (
            <div
              key={ticket.id}
              className={`${classes.conversationCard} ${isSelected ? classes.selectedConversation : ""}`}
              onClick={() => openConversation(ticket)}
            >
              <Badge
                overlap="circular"
                variant="dot"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                color="primary"
              >
                <Avatar src={ticket.contact?.urlPicture || ticket.contact?.profilePicUrl}>
                  {name.charAt(0)}
                </Avatar>
              </Badge>

              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <Typography className={classes.convName}>{name}</Typography>
                  <Typography className={classes.convTime}>{formatTime(ticket.updatedAt)}</Typography>
                </div>
                <Typography className={classes.convMsg}>
                  {ticket.lastMessage || "Sem mensagens recentes"}
                </Typography>
                <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
                  {ticket.tags?.slice(0, 2).map(tag => (
                    <Chip key={tag.id} size="small" label={tag.name} style={{ background: tag.color || "#DBEAFE", color: "#0F172A", height: 22, fontWeight: 800 }} />
                  ))}
                  {ticket.queue?.name && (
                    <Chip size="small" label={ticket.queue.name} style={{ background: "#DCFCE7", color: "#166534", height: 22, fontWeight: 800 }} />
                  )}
                </div>
              </div>

              {unread > 0 && (
                <Chip size="small" label={unread} style={{ background: "#2563EB", color: "#fff", fontWeight: 900 }} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderChat = () => (
    <div className={`${classes.panel} ${classes.chatPanel} ${classes.mobileFull}`}>
      <div className={classes.chatHeader}>
        <div className={classes.chatUser}>
          {isMobile && (
            <IconButton onClick={() => setMobileView("list")}>
              <ArrowBackIcon />
            </IconButton>
          )}
          <Avatar src={selected?.contact?.urlPicture || selected?.contact?.profilePicUrl}>
            {(selected?.contact?.name || "C").charAt(0)}
          </Avatar>
          <div>
            <Typography style={{ fontWeight: 900, color: "#0F172A" }}>
              {selected?.contact?.name || "Selecione uma conversa"}
            </Typography>
            <Typography style={{ color: "#22C55E", fontSize: 13 }}>
              {selected ? "Online" : "Central de conversas"}
            </Typography>
          </div>
        </div>

        {selected && (
          <div>
            <IconButton><LocalOfferIcon /></IconButton>
            <IconButton><MoreVertIcon /></IconButton>
          </div>
        )}
      </div>

      <div className={classes.chatBody}>
        <div className={classes.day}>Hoje</div>

        {!selected ? (
          <div style={{ textAlign: "center", marginTop: 120 }}>
            <Typography style={{ fontWeight: 900, color: "#0F172A", fontSize: 22 }}>Central de Conversas</Typography>
            <Typography style={{ color: "#64748B", marginTop: 8 }}>Selecione uma conversa para começar.</Typography>
          </div>
        ) : (
          <>
            <div className={classes.bubbleLeft}>
              <Typography>{selected.lastMessage || "Mensagem do cliente."}</Typography>
              <div className={classes.bubbleTime}>{formatTime(selected.updatedAt)}</div>
            </div>

            <div className={classes.bubbleRight}>
              <Typography>Esta é a nova experiência visual da Korax. Clique em “Abrir conversa real” para usar todos os recursos atuais.</Typography>
              <div className={classes.bubbleTime}>agora ✓✓</div>
            </div>

            <Button
              variant="contained"
              color="primary"
              onClick={goRealConversation}
              style={{ borderRadius: 999, textTransform: "none", fontWeight: 900, marginTop: 12 }}
            >
              Abrir conversa real
            </Button>
          </>
        )}
      </div>

      <div className={classes.composer}>
        <div className={classes.inputRow}>
          <IconButton><AddIcon /></IconButton>
          <div className={classes.inputBox}>
            <InputBase placeholder="Digite uma mensagem..." style={{ flex: 1 }} />
            <AttachFileIcon style={{ color: "#64748B" }} />
          </div>
          <IconButton className={classes.greenButton}>
            {selected ? <SendIcon /> : <MicIcon />}
          </IconButton>
        </div>

        <div className={classes.quickActions}>
          <Button className={classes.quickBtn} startIcon={<FlashOnIcon />}>Respostas rápidas</Button>
          <Button className={classes.quickBtn} startIcon={<EventIcon />}>Agendar</Button>
          <Button className={classes.quickBtn} startIcon={<LocalOfferIcon />}>Tag</Button>
          <Button className={classes.quickBtn}>Follow-up</Button>
          <Button className={classes.quickBtn}>Mais</Button>
        </div>
      </div>
    </div>
  );

  const renderDetails = () => (
    <div className={`${classes.panel} ${classes.rightPanel}`}>
      <div className={classes.detailsHeader}>
        <Avatar
          src={selected?.contact?.urlPicture || selected?.contact?.profilePicUrl}
          style={{ width: 62, height: 62, margin: "0 auto 8px" }}
        >
          {(selected?.contact?.name || "C").charAt(0)}
        </Avatar>
        <Typography style={{ fontWeight: 900, color: "#0F172A" }}>
          {selected?.contact?.name || "Contato"}
        </Typography>
        <Typography style={{ color: "#22C55E", fontSize: 13 }}>Online</Typography>
      </div>

      <div className={classes.detailTabs}>
        <span className={`${classes.detailTab} ${classes.detailTabActive}`}>Detalhes</span>
        <span className={classes.detailTab}>Histórico</span>
        <span className={classes.detailTab}>Notas</span>
      </div>

      <div className={classes.infoCard}>
        <Typography className={classes.infoTitle}>Informações</Typography>
        <div className={classes.infoRow}><PhoneIcon fontSize="small" /> {selected?.contact?.number || "Telefone não informado"}</div>
        <div className={classes.infoRow}><WhatsAppIcon fontSize="small" /> WhatsApp</div>
        <div className={classes.infoRow}><LocalOfferIcon fontSize="small" /> {selected?.queue?.name || "Sem setor"}</div>
      </div>

      <div className={classes.infoCard}>
        <Typography className={classes.infoTitle}>Dados da conversa</Typography>
        <div className={classes.infoRow}>Responsável: {selected?.user?.name || "Sem responsável"}</div>
        <div className={classes.infoRow}>Canal: {selected?.whatsapp?.name || "WhatsApp"}</div>
        <div className={classes.infoRow}>Última mensagem: {selected ? formatTime(selected.updatedAt) : "-"}</div>
      </div>

      <div className={classes.infoCard}>
        <Typography className={classes.infoTitle}>Ações</Typography>
        <Button className={classes.actionButton} onClick={goRealConversation}>Abrir conversa real</Button>
        <Button className={classes.actionButton}>Ver no CRM</Button>
        <Button className={classes.actionButton} style={{ color: "#EF4444" }}>Finalizar conversa</Button>
      </div>
    </div>
  );

  return (
    <div className={classes.root}>
      {isMobile ? (
        mobileView === "list" ? renderList() : renderChat()
      ) : (
        <div className={classes.shell}>
          {renderList()}
          {renderChat()}
          {renderDetails()}
        </div>
      )}
    </div>
  );
};

export default ConversasV2;
